import './style.scss'
import { useContext, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import ApiContext from 'src/provider/API/call-service';
import AppInfoContext from 'src/provider/state-manager/appInfoProvider';
import VisibilityContext from 'src/provider/state-manager/visibilityProvider';
import { AppSpan, AppText, Button, Circle, CustomContainer, FlexColumn, FlexRow, GridContainer, Icon } from 'src/style'
import { IoIosArrowBack } from "react-icons/io";
import ProfileBgImg from 'src/assets/img/profile-bg-img.svg'
import utility, { moneyFormat } from 'src/utils/utility';
import { ChangePassword } from 'src/popup';
import { useEffect } from 'react';
import UserPics from 'src/assets/img/rhydhur_pic.jpg'
import {ReactComponent as LockIcon} from 'src/assets/img/lock-icon.svg'
import { UserTypes } from 'src/model';
import helpers from 'src/utils/helpers';
import { ChangeLimit } from './popups/change-limit';
import {useTranslation} from 'react-i18next';


const Profile = () => {
    const navigate = useNavigate()
    const {API} = useContext(ApiContext)
    const {decisionBox} = useContext(VisibilityContext)
    const {info: {selectedUser, userType, profileTypeAccess}} = useContext(AppInfoContext)
    const [user, setUser] = useState<any>(null)
    const [userRole, setUserRole] = useState('')
    const [accessType, setAccessType] = useState(profileTypeAccess)
    const [view, setView] = useState('')
    const [accountLimit, setAccountLimit] = useState([])
    const { t } = useTranslation()
 
    const handleFetchAccountLimits = async() => {
        const response = await API.getProfileAccountLimits(user?.id)
        setAccountLimit(response)
    }

    useEffect(()=>{
        if(user){ 
            handleFetchAccountLimits() 
        }
    },[user,view])

    useEffect(() => {
        if (selectedUser) setUser(selectedUser)
    }, [selectedUser])

    useEffect(() => {
        if (profileTypeAccess) setAccessType(profileTypeAccess)
    }, [profileTypeAccess])

    useEffect(() => {
        setUserRole(userType)
    }, [userType])

    function handleUserAction (type: string) {
        let action;
        
        if (type === 'activate') action = handleRestoreProfile
        else if (type === 'reset') action = handleResetUser
        else if (['lock', 'unlock'].includes(type)) action = handleLock_UnlockUser

        decisionBox.show(
            t('customer.profile.details.confirmAction',{action:type}),
            action,
            decisionBox.hide,
            t('customer.profile.details.yes',{action:type}),
            t('customer.profile.details.no'),
        )
    }

    async function handleLock_UnlockUser() {
        const response = !user.isLocked ? await API.lockUser(user.id) : await API.unlockUser(user.id)
        if (response) navigate(-1)
    }

    async function handleRestoreProfile() {
        const response = await API.restoreProfile(user.id)
        if (response) navigate(-1)
    }

    async function handleResetUser() {
        const response = await API.resetUserProfile(user.id)
        if (response) navigate(-1)
    }

    return (
        <>
            <CustomContainer 
                className='profile-container'
            >
                <CustomContainer>
                    <FlexRow 
                        justifyContent='flex-start' gap='1'
                        width='auto' sizeUnit=''
                        onClick={() => navigate(-1)}
                    >
                        <AppSpan textSize='2' cursor='pointer' >
                            <IoIosArrowBack />
                        </AppSpan>
                        <AppText 
                            textSize='3' fontWeight='600' color='#101828' cursor='pointer'
                        >
                            {t('customer.profile.details.title')} ({user?.firstName} {user?.lastName})
                        </AppText>
                    </FlexRow>
                        <FlexColumn 
                            className='profile-details-container'
                            bgColor='#ffffff' minHeight='22.3'
                            radius='0.8' padding='2' justifyContent='space-between'
                        >
                            <FlexRow 
                                justifyContent='flex-start' alignItems='flex-start'
                                gap='4' wrap='wrap'
                            >
                                <CustomContainer width='auto' sizeUnit=''>
                                    <AppText color='#58595B' fontWeight='700'>{t('customer.profile.details.fullName')}</AppText>
                                    <AppSpan color='#A098AE'>{user?.firstName}{user?.lastName}</AppSpan>
                                </CustomContainer>
                                <CustomContainer width='auto' sizeUnit=''>
                                    <AppText color='#58595B' fontWeight='700'>{t('customer.profile.details.email')}</AppText>
                                    <AppSpan color='#A098AE'>{user?.emailAddress}</AppSpan>
                                </CustomContainer>
                                <CustomContainer width='auto' sizeUnit=''>
                                    <AppText color='#58595B' fontWeight='700'>{t('customer.profile.details.username')}</AppText>
                                    <AppSpan color='#A098AE'>{user?.username}</AppSpan>
                                </CustomContainer>
                                <CustomContainer width='auto' sizeUnit=''>
                                    <AppText color='#58595B' fontWeight='700'>{t('customer.profile.details.customerId')}</AppText>
                                    <AppSpan color='#A098AE' >{user?.customerID}</AppSpan>
                                </CustomContainer>
                                <CustomContainer width='auto' sizeUnit=''>
                                    <AppText color='#58595B' fontWeight='700'>{t('customer.profile.details.bvn')}</AppText>
                                    <AppSpan color='#A098AE'>{user?.bvn}</AppSpan>
                                </CustomContainer>
                                <CustomContainer width='auto' sizeUnit=''>
                                    <AppText color='#58595B' fontWeight='700'>{t('customer.profile.details.phoneNumber')}</AppText>
                                    <AppSpan color='#A098AE'>{user?.phoneNumber}</AppSpan>
                                </CustomContainer>
                                <CustomContainer width='auto' sizeUnit=''>
                                    <AppText color='#58595B' fontWeight='700'>{t('customer.profile.details.gender')}</AppText>
                                    <AppSpan color='#A098AE'>{user?.gender}</AppSpan>
                                </CustomContainer>
                                <CustomContainer width='auto' sizeUnit=''>
                                    <AppText color='#58595B' fontWeight='700'>{t('customer.profile.details.creationDate')}</AppText>
                                    <AppSpan color='#A098AE'>{user?.creationDate && helpers.handleDate(user?.creationDate)}</AppSpan>
                                </CustomContainer>
                                <CustomContainer width='auto' sizeUnit=''>
                                    <AppText color='#58595B' fontWeight='700'>{t('customer.profile.details.primaryAccount')}</AppText>
                                    <AppSpan color='#A098AE'>{user?.primaryAccount}</AppSpan>
                                </CustomContainer>
                                <CustomContainer width='auto' sizeUnit=''>
                                    <AppText color='#58595B' fontWeight='700'>{t('customer.profile.details.statusLabel')}</AppText>
                                    <GridContainer 
                                        width='6.5' height='2.2' radius='1.6' 
                                        bgColor={!user?.isDeleted ? '#ECFDF3' : '#FFEBEA'}
                                    >
                                        <AppSpan 
                                            textSize='1.2' fontWeight='500' 
                                            color={!user?.isDeleted ? '#027A48' : '#D30202'}
                                        >
                                            {!user?.isDeleted ? t('customer.profile.details.status.active') : t('customer.profile.details.status.inactive')}
                                        </AppSpan>
                                    </GridContainer>
                                </CustomContainer>
                            </FlexRow>
                            <FlexRow justifyContent='flex-end' gap='1.5' wrap='wrap' topMargin='3'>
                            { (userRole === UserTypes.ADMIN && accessType === 'customers') &&
                                <>
                                    <Button
                                        width='13.1' bgColor='transparent'
                                        titleSize='1.4' fontWeight='600' 
                                        borderColor='#ffffff' shadow='none'
                                        height='4' radius='0.8' color='#0A756F'
                                        bottomMargin='1' hoverColor='#0A756F'
                                        hoverBgColor='#fff' hoverBorderColor='#0A756F'
                                        onClick={() => handleUserAction(user?.isLocked ? 'unlock' : 'lock')}
                                    >
                                        <AppSpan rightMargin='0.7'>
                                            <LockIcon />
                                        </AppSpan>
                                        {user?.isLocked ? t('customer.profile.details.actions.unlockUser') : t('customer.profile.details.actions.lockUser')}
                                    </Button>
                                    { user?.isDeleted &&
                                        <Button
                                            width='14.1' bgColor='#E7F6F5'
                                            titleSize='1.4' fontWeight='600'
                                            height='4' radius='0.8' color='#0D968F'
                                            bottomMargin='1' hoverColor='#0D968F'
                                            hoverBgColor='#fff' hoverBorderColor='#0D968F'
                                            onClick={() => handleUserAction('activate')}
                                        >
                                            {t('customer.profile.details.actions.activateUser')}
                                        </Button>
                                    }
                                    <Button
                                        width='14.1' bgColor='#FEF3F2'
                                        titleSize='1.4' fontWeight='600'
                                        height='4' radius='0.8' color='#D30202'
                                        bottomMargin='1' hoverColor='#D30202'
                                        hoverBgColor='#fff' hoverBorderColor='#D30202'
                                        onClick={() => handleUserAction('reset')}
                                    > 
                                        {t('customer.profile.details.actions.resetUser')}
                                    </Button>
                                </>
                            }
                            { accessType === 'user' &&
                                <Button
                                    width='15.5'
                                    titleSize='1.4' fontWeight='600'
                                    height='4' radius='0.8'
                                    bottomMargin='1' hoverColor='#0D968F'
                                    hoverBgColor='#fff' borderColor='#0D968F'
                                    onClick={() => setView('change-password')}
                                >
                                    {t('customer.profile.details.actions.changePassword')}
                                </Button>
                            }
                            </FlexRow>
                        </FlexColumn>
                        
                              <CustomContainer>
                              <AppText
                                  textSize='2' fontWeight='900' color='#101828' topMargin='2' 
                              >
                                  {t('customer.profile.details.transactionLimit')}
                              </AppText>
      
                              <FlexColumn
                                  className='profile-details-container'
                                  bgColor='#ffffff' minHeight='15' topMargin='2'
                                  radius='0.8' leftPadding='2' rightPadding='2' bottomPadding='2' justifyContent='flex-start'
                              >
                                {accountLimit && accountLimit?.map((item:any, index)=>{
                                    return(
                                        <FlexRow 
                                      justifyContent='flex-start' alignItems='flex-start' topMargin='5'
                                      gap='7' wrap='wrap' key={index} 
                                  >
                                      <CustomContainer width='auto' sizeUnit=''>
                                          <AppText color='#58595B' fontWeight='700'>{t('customer.profile.details.title')}</AppText>
                                          <AppSpan color='#A098AE'>{item?.accountNumber}</AppSpan>
                                      </CustomContainer>
                                      <CustomContainer width='auto' sizeUnit=''>
                                          <AppText color='#58595B' fontWeight='700'>{t('customer.profile.details.singleLimit')}</AppText>
                                          <AppSpan color='#A098AE'>{moneyFormat(item?.oneTimeLimit)}</AppSpan>
                                      </CustomContainer>
                                      <CustomContainer width='auto' sizeUnit=''>
                                          <AppText color='#58595B' fontWeight='700'>{t('customer.profile.details.dailyLimit')}</AppText>
                                          <AppSpan color='#A098AE'>{moneyFormat(item?.dailyLimit)}</AppSpan>
                                      </CustomContainer>
                                      
                                  </FlexRow>
                                    )
                                })}

                                {(userRole === UserTypes.ADMIN && accessType === 'customers') && (
                                     <FlexRow justifyContent='end'>
                                     <Button
                                         width='14.1' bgColor='#E7F6F5'
                                         titleSize='1.4' fontWeight='600'
                                         height='4' radius='0.8' color='#0D968F'
                                         bottomMargin='1' hoverColor='#0D968F' 
                                         hoverBgColor='#fff' hoverBorderColor='#0D968F'
                                         onClick={() => setView('change-limit')}
                                     >
                                        {t('customer.profile.details.actions.changeLimit')}
                                     </Button>
                                     </FlexRow>
                                )}    
                              </FlexColumn>
                              </CustomContainer>
                        
                      

                   
                </CustomContainer>
            </CustomContainer>
            { view === 'change-password' &&
                <ChangePassword
                    close={() => setView('')} 
                />
            }
             { view === 'change-limit' &&
                <ChangeLimit
                    close={() => setView('')} 
                    accounts ={accountLimit}
                />
            }
        </>
    )
}

export default utility.routeData('user-profile', 'User Profile', <Profile/>)